import { I18N } from "./I18N.js"

export class Menu {
	_target
	_appContext

	constructor(target, appContext) {
		this._appContext = appContext
		this._target = document.getElementById(target)
		this._target.innerHTML = `
			<ul>
				<li id="headerBranding"><div class="logo"><img src="https://viertel-lieferservice.de/wp-content/uploads/2021/04/Lieferservice-Logo_gruen_trans.png" alt="VLS logo"></div><div class="label">Viertel-Lieferservice</div></li>
				<li><a id="storesMenuItem" href="stores" i18n>Choose Store</a></li>
				<li><a id="productsMenuItem" href="products" i18n>Products</a></li>
				<li><a id="aboutUsMenuItem" href="aboutUs" i18n>About Us</a></li>
				<li><a id="myordersMenuItem" href="myorders" i18n>My Orders</a></li>
				<li><a id="checkoutMenuItem" href="checkout" i18n>Checkout</a></li>
				<li><a id="loginMenuItem" href="login" i18n>Login</a></li>
				<li><a id="accountMenuItem" href="account" i18n>My Account</a></li>
			</ul>
			<ul>
				<li>
					<a id="cartMenuItem" class="block" href="cart" alwaysVisible>
						<div id="cart-mini" class="clickable"></div>
					</a>
				</li>
			</ul>`
		this._target.querySelectorAll('a').forEach(a => {
			const href = a.getAttribute('href')
			if (this._appContext.isActive(href)) {
				a.setAttribute('active', '')
			}
			if (!this._appContext.isOpen(href)) {
				a.setAttribute('disabled', '')
			}
			if (href === 'myorders') {
				a.addEventListener('click', ev => {
					ev.preventDefault()
					this._target.querySelectorAll('a').forEach(a => a.removeAttribute('active'))
					ev.currentTarget.setAttribute('active', '')
					this._appContext.setActive('myorders')
				})
			} else {
				a.addEventListener('click', ev => {
					ev.preventDefault()
					this._target.querySelectorAll('a').forEach(a => a.removeAttribute('active'))
					ev.currentTarget.setAttribute('active', '')
					this._appContext.setActive(href)
					return null
				})
			}
		})
		I18N.translateElement(this._target)
	}

	/**
	 * Called by context to show or hide menu entry.
	 * 
	 * @param {*} activity 
	 * @param {*} open 
	 */
	setOpen = (activity, open) => {
		const selector = activity === 'confirmation' ? 'a[href=myorders]' : `a[href=${activity}]`
		if (!open && activity === 'confirmation') {
			const hasHistory = JSON.parse(localStorage.getItem('orderHistory') || '[]').length > 0
			if (hasHistory) return
		}
		this._target.querySelectorAll(selector).forEach(a => open ? a.removeAttribute('disabled') : a.setAttribute('disabled', ''))
	}

	/**
	 * Called by context to set menu entry active.
	 *
	 * @param {*} activity
	 */
	setActive = activity => {
		this.setOpen(activity, true)
		this._target.querySelectorAll('a').forEach(a => a.removeAttribute('active'))
		const selector = activity === 'confirmation' ? 'a[href=myorders]' : `a[href=${activity}]`
		this._target.querySelector(selector)?.setAttribute('active', '')
	}

}